import request from "@/commons/request";
import storage from '@/commons/storage';
import message from "@/components/message";

const vtk = { request, storage, message, env: process.env }

export default vtk;

